import { JSX, Show } from "solid-js";
import HubbleImage from "~/widgets/hubble_image";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";

/**
 * About Brand section with logo and description
 */
export function AboutBrandSection(): JSX.Element {
  const { routeData, brandDescription } = useBrandl2WebstoreTelescopeContext();

  const logoUrl = () => routeData().brand.voucherProductMetadata.iconImageUrl;
  const brandName = () => routeData().brand.name;

  return (
    <Show when={brandDescription()}>
      <div class="flex gap-4">
        <div class="flex w-full flex-col gap-4">
          {/* Section Header */}
          <h2 class="text-title-4-semi-bold text-text-normal-primary">
            About {brandName()}
          </h2>

          {/* Content */}
          {/* Description */}
          <div class="flex flex-1 flex-col gap-2">
            <p class="text-para-3-regular text-text-normal-secondary">
              {brandDescription()}
            </p>
          </div>
        </div>
        {/* Brand Logo */}
        <div class="flex shrink-0 items-start">
          <div class="flex h-[120px] w-[108px] items-center justify-center overflow-hidden rounded-2xl">
            <HubbleImage
              src={logoUrl()}
              alt={`${brandName()} logo`}
              class="h-full w-full object-contain"
            />
          </div>
        </div>
      </div>
    </Show>
  );
}
